import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_115: FaireProductEntity = {
  token: "legacy_prod_abbott-115",
  type: "product",
  name: "Beehive Covered Pot",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4bddb41c25ccc27f4d806af8a433b6e3920ca817adf6ed071115cd4541b80435.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
